module.exports = __webpack_public_path__ + "img/Leaguebuilding2.86993796.png";